import {
  REQUEST_INITIAL,
  REQUEST_ERROR,
  REQUEST_INPROGRESS,
  REQUEST_SUCCESS,
} from 'store/constants';

export const PREORDER_REQUEST = 'ProductDetails::Preorder::Request';
export const PREORDER_SUCCESS = 'ProductDetails::Preorder::Success';
export const PREORDER_ERROR = 'ProductDetails::Preorder::Error';

export const PREORDER_PAYMENT_REQUEST = 'ProductDetails::Preorder::Payment::Request';
export const PREORDER_PAYMENT_SUCCESS = 'ProductDetails::Preorder::Payment::Success';
export const PREORDER_PAYMENT_ERROR = 'ProductDetails::Preorder::Payment::Error';

export const SET_PREORDER_NOTIFICATION_METHOD = 'ProductDetails::Preorder::SetNotificationMethod';
export const OPEN_PREORDER_PAYMENT_FORM = 'ProductDetails::Preorder::OpenPaymentForm';

export const PREORDER_CALLBACK_SUCCESS = 'ProductDetails::Preorder::CallbackSuccess';
export const PREORDER_CALLBACK_ERROR = 'ProductDetails::Preorder::CallbackError';
export const PREORDER_INITIALIZE = 'ProductDetails::Preorder::Initialize';
export const PREORDER_HAS_ONLINE_PAYMENT = 'ProductDetails::Preorder::HasOnlinePayment';

export const PREORDER_STATUS_INITIAL = REQUEST_INITIAL;
export const PREORDER_STATUS_INPROGRESS = REQUEST_INPROGRESS;
export const PREORDER_STATUS_SUCCESS = REQUEST_SUCCESS;
export const PREORDER_STATUS_ERROR = REQUEST_ERROR;

export const PAYMENT_STATUS_INPROGRESS = `payment-${REQUEST_INPROGRESS}`;
export const PAYMENT_STATUS_SUCCESS = `payment-${REQUEST_SUCCESS}`;
export const PAYMENT_STATUS_ERROR = `payment-${REQUEST_ERROR}`;

export const CALLBACK_STATUS_SUCCESS = `callback-${REQUEST_SUCCESS}`;
export const CALLBACK_STATUS_ERROR = `callback-${REQUEST_ERROR}`;

export const SUCCESS_SCROLL_ID = 'preorder_success';
